import { chainsMetadata } from "data/rpc";
import { printFiat } from "logic/utils";
import { Drawer, ExternalLink } from "ui/components";

import { Loan } from "../data/types";

type Props = {
  loan: Loan;
  tokenId: bigint;
  isOpen: boolean;
  onClose: () => void;
};

export function NftDetailsDrawer({ loan, tokenId, isOpen, onClose }: Props) {
  const nftMeta = loan.nfts.metadata[tokenId.toString()];
  const meta = nftMeta?.metadata;

  return (
    <Drawer isOpen={isOpen} onClose={onClose} className="max-w-[780px] w-full !px-[47px] !py-[43px]">
      <div className="flex items-center gap-[11px]">
        {meta?.image ? (
          <img src={meta.image} alt={meta.name} className="size-[50px] object-cover shrink-0" />
        ) : (
          <div className="size-[50px] bg-outline-minor shrink-0" />
        )}
        <div className="flex flex-col min-w-0">
          <span className="text-[20px] font-medium leading-[1.3] tracking-[-0.4px] text-text-primary">
            {meta?.name ?? "NFT Details"}
          </span>
          <div className="flex items-center gap-[12px] text-[14px] leading-[1.5] tracking-[-0.14px]">
            <span className="text-text-disabled">Token ID# {tokenId.toString()}</span>
            <ExternalLink
              href={`${chainsMetadata[loan.chainId].explorerUrl}/nft/${loan.nfts.collection}/${tokenId.toString()}`}
              className="text-text-secondary"
            >
              View on {chainsMetadata[loan.chainId].explorerName} →
            </ExternalLink>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-[24px] mt-[24px] text-[14px] leading-[1.5] tracking-[-0.14px]">
        {meta && (
          <>
            <MetadataRow label="Description" value={meta.description} />
            <MetadataRow label="Model" value={meta.model} />
            <MetadataRow label="Manufacturer" value={meta.manufacturer} />
            <MetadataRow label="Collateral Value" value={printFiat(meta.collateralValueUSD)} />
            <MetadataRow label="Serial Number" value={meta.serialNumber} />
            <MetadataRow label="Server Rack" value={meta.serverRack} />
            <MetadataRow label="Unit Number" value={meta.unitNumber} />
            <MetadataRow label="Quantity" value={meta.quantity.toString()} />
            <MetadataRow label="Useful Life" value={`${meta.usefulLifeDays} days`} />
          </>
        )}
      </div>
    </Drawer>
  );
}

function MetadataRow({ label, value }: { label: string; value: string }) {
  if (!value) return null;

  return (
    <div className="flex flex-col">
      <span className="font-medium text-text-secondary">{label}</span>
      <span className="text-text-primary">{value}</span>
    </div>
  );
}
